import { EnvironmentFilled, InfoCircleFilled } from '@ant-design/icons';
import { Alert, Space } from 'antd';
import React, { useMemo } from 'react';
import RichTextViewer from '../../../helpers/components/rich_text_viewer';
import { isRichTextEmpty } from '../../../helpers/functions/rich_text.helper';

const Address = ({ address, description, }) => {
    const has_description = useMemo(() => !isRichTextEmpty(description), [description]);

    // this is checking if there is no address and desc
    if(!address && !has_description) return null;

    return (
        <>
            <div style={{ padding : '0 24px'}}>
                <div style={{textAlign:'start', background:'var(--secondary-button-color)', borderRadius:8, marginTop:12,}}>
                    <div style={{padding: 12,}}>
                        <Space direction='vertical' style={{ width : '100%', }}>
                            {
                                address && (
                                    <div>
                                        <Space align='start'>
                                            <EnvironmentFilled style={{ color : 'var(--secondary-text-color)', }} />
                                            <div>
                                                <span
                                                className='ticket-label ticket-title h1'
                                                style={{ fontSize:12, color:'var(--secondary-text-color)', whiteSpace : 'wrap',}}
                                                >
                                                    {address}
                                                </span>
                                            </div>
                                        </Space>
                                    </div>
                                )
                            }
                            {
                                has_description && (
                                    <>
                                        <div>
                                            <Space align='start'>
                                                <InfoCircleFilled style={{ color : 'var(--secondary-text-color)', }} />
                                                <div>
                                                    <RichTextViewer
                                                    value={description}
                                                    className='ticket-label ticket-title h1 description-quill'
                                                    style={{ fontSize:12, color:'var(--secondary-text-color)', whiteSpace : 'wrap', margin : 0, }}
                                                    />
                                                </div>
                                            </Space>
                                        </div>
                                    </>
                                )
                            }
                        </Space>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Address;